export const ACTION_CLICK_BUY_CAR = 'Action: Click Buy Car';
